const storeShippingDaysConfig = {
    holidays: [{
        "name": "New Year's Day",
        "date": "2026-01-01",
    },
    {
        "name": "Martin Luther King Jr. Day",
        "date": "2026-01-19",
    },
    {
        "name": "Presidents' Day",
        "date": "2026-02-16",
    },
    {
        "name": "Memorial Day",
        "date": "2026-05-25",
    },
    {
        "name": "Juneteenth",
        "date": "2026-06-19",
    },
    {
        "name": "Independence Day",
        "date": "2026-07-03",
    },
    {
        "name": "Labor Day",
        "date": "2026-09-07",
    },
    {
        "name": "Columbus Day",
        "date": "2026-10-12",
    },
    {
        "name": "Veterans Day",
        "date": "2026-11-11",
    },
    {
        "name": "Thanksgiving Day",
        "date": "2026-11-26",
    },
    {
        "name": "Christmas Day",
        "date": "2026-12-25",
    },
    {
        "name": "New Year's Day",
        "date": "2027-01-01",
    },
    {
        "name": "Martin Luther King Jr. Day",
        "date": "2027-01-18",
    },
    {
        "name": "Presidents' Day",
        "date": "2027-02-15",
    },
    {
        "name": "Memorial Day",
        "date": "2027-05-31",
    },
    {
        "name": "Juneteenth",
        "date": "2027-06-18",
    },
    {
        "name": "Independence Day",
        "date": "2027-07-05",
    },
    {
        "name": "Labor Day",
        "date": "2027-09-06",
    },
    {
        "name": "Columbus Day",
        "date": "2027-10-11",
    },
    {
        "name": "Veterans Day",
        "date": "2027-11-11",
    },
    {
        "name": "Thanksgiving Day",
        "date": "2027-11-25",
    },
    {
        "name": "Christmas Day",
        "date": "2027-12-24",
    },
    {
        "name": "New Year's Day",
        "date": "2027-12-31",
    },
    {
        "name": "Martin Luther King Jr. Day",
        "date": "2028-01-17",
    },
    {
        "name": "Presidents' Day",
        "date": "2028-02-21",
    },
    {
        "name": "Memorial Day",
        "date": "2028-05-29",
    },
    {
        "name": "Juneteenth",
        "date": "2028-06-19",
    },
    {
        "name": "Independence Day",
        "date": "2028-07-04",
    },
    {
        "name": "Labor Day",
        "date": "2028-09-04",
    },
    {
        "name": "Columbus Day",
        "date": "2028-10-09",
    },
    {
        "name": "Veterans Day",
        "date": "2028-11-10",
    },
    {
        "name": "Thanksgiving Day",
        "date": "2028-11-23",
    },
    {
        "name": "Christmas Day",
        "date": "2028-12-25",
    },
    {
        "name": "New Year's Day",
        "date": "2029-01-01",
    },
    {
        "name": "Inauguration Day",
        "date": "2029-01-20",
    },
    {
        "name": "Martin Luther King Jr. Day",
        "date": "2029-01-15",
    },
    {
        "name": "Presidents' Day",
        "date": "2029-02-19",
    },
    {
        "name": "Memorial Day",
        "date": "2029-05-28",
    },
    {
        "name": "Juneteenth",
        "date": "2029-06-19",
    },
    {
        "name": "Independence Day",
        "date": "2029-07-04",
    },
    {
        "name": "Labor Day",
        "date": "2029-09-03",
    },
    {
        "name": "Columbus Day",
        "date": "2029-10-08",
    },
    {
        "name": "Veterans Day",
        "date": "2029-11-12",
    },
    {
        "name": "Thanksgiving Day",
        "date": "2029-11-22",
    },
    {
        "name": "Christmas Day",
        "date": "2029-12-25",
    },
    {
        "name": "New Year's Day",
        "date": "2030-01-01",
    },
    {
        "name": "Martin Luther King Jr. Day",
        "date": "2030-01-21",
    },
    {
        "name": "Presidents' Day",
        "date": "2030-02-18",
    },
    {
        "name": "Memorial Day",
        "date": "2030-05-27",
    },
    {
        "name": "Juneteenth",
        "date": "2030-06-19",
    },
    {
        "name": "Independence Day",
        "date": "2030-07-04",
    },
    {
        "name": "Labor Day",
        "date": "2030-09-02",
    },
    {
        "name": "Columbus Day",
        "date": "2030-10-14",
    },
    {
        "name": "Veterans Day",
        "date": "2030-11-11",
    },
    {
        "name": "Thanksgiving Day",
        "date": "2030-11-28",
    },
    {
        "name": "Christmas Day",
        "date": "2030-12-25",
    }],
    shippingDaysMin: 2,
    shippingDaysMax: 5,
    shippingDaysMinGreenhouse: 4,
    shippingDaysMaxGreenhouse: 8
};

const storeShippingDaysGreenhouseProducts = [
    "vego-garden-pacific-greenhouse",
    "vego-garden-pacific-greenhouse-10-5-ft",
    "vego-garden-junior-victorian-greenhouse-6-5-ft",
    "vego-garden-victorian-greenhouse-85-ft",
    "vego-garden-junior-victoria-greenhouse-8-0-ft",
    "vego-garden-victorian-greenhouse-10-5-ft",
    "vego-garden-pacific-greenhouse-12-5-ft",
    "vego-garden-victorian-greenhouse-12-5-ft",
    "vego-diamond-pavilion-greenhouse",
    "vego-grand-pacific-greenhouse-12-5ft-wide-4-tier-grow-light-garden-pro-with-bistro-set",
    "vego-grand-victorian-greenhouse-12-5ft-wide-4-tier-grow-light-garden-pro-with-bistro-set",
    "vego-diamond-pavilion-greenhouse-bistro-set",
    "lean-to-greenhouse-4-5-x-8-5",
    "lean-to-greenhouse-6-5-x-8-5",
    "lean-to-greenhouse-8-5-x-12-5"
];

class BusinessDaysCalculator {
    constructor(config = {}) {
        this.holidaySet = new Set();
        if (config.holidays) {
            this.setHolidays(config.holidays);
        }
    }

    setHolidays(holidayConfig) {
        this.holidaySet.clear();
        holidayConfig.forEach(item => {
            let targetDateStr = typeof item === 'string' ? item : item.date;
            let daysOff = (typeof item === 'object' && item.daysOff) ? item.daysOff : 1;

            if (!targetDateStr) return;

            const [year, month, day] = targetDateStr.split('-').map(Number);
            let currentHolidayDate = new Date(year, month - 1, day);

            for (let i = 0; i < daysOff; i++) {
                const dateStr = this._formatDate(currentHolidayDate);
                this.holidaySet.add(dateStr);
                currentHolidayDate.setDate(currentHolidayDate.getDate() + 1);
            }
        });
    }

    _formatDate(dateObj) {
        const year = dateObj.getFullYear();
        const month = String(dateObj.getMonth() + 1).padStart(2, '0');
        const day = String(dateObj.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    }

    isNonWorkingDay(dateObj) {
        const dayOfWeek = dateObj.getDay();
        const isWeekend = dayOfWeek === 0 || dayOfWeek === 6;
        const isHoliday = this.holidaySet.has(this._formatDate(dateObj));
        
        return isWeekend || isHoliday; 
    }

    addDays(baseDate, daysToAdd) {
        let currentDate = new Date(baseDate.getTime());
        let addedDays = 0;

        while (addedDays < daysToAdd) {
            currentDate.setDate(currentDate.getDate() + 1);
            if (!this.isNonWorkingDay(currentDate)) {
                addedDays++;
            }
        }
        return currentDate;
    }

    getDateRangeString(baseDate, minDays, maxDays) {
        const formatOptions = { month: 'short', day: 'numeric' };
        const minDate = this.addDays(baseDate, minDays);
        const maxDate = this.addDays(baseDate, maxDays);
        return `${minDate.toLocaleDateString('en-US', formatOptions)} - ${maxDate.toLocaleDateString('en-US', formatOptions)}`;
    }
}

$(document).ready(function () {
    if ($('.fast-shipping-arrives-day').length) {
        const calculator = new BusinessDaysCalculator({ holidays: storeShippingDaysConfig.holidays });

        const now = new Date();
        // 👇 这里移除了时区相关的逻辑，直接根据用户本地浏览器时间提取“年月日”来初始化 today
        const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());

        const cleanPathname = window.location.pathname.split('?')[0].split('#')[0];
        const pathArray = cleanPathname.split('/').filter(Boolean);
        const pageHandle = pathArray.pop() || '';

        let minDays = storeShippingDaysConfig.shippingDaysMin;
        let maxDays = storeShippingDaysConfig.shippingDaysMax;

        if (storeShippingDaysGreenhouseProducts.includes(pageHandle)) {
            minDays = storeShippingDaysConfig.shippingDaysMinGreenhouse;
            maxDays = storeShippingDaysConfig.shippingDaysMaxGreenhouse;
        }

        const deliveryDate = calculator.getDateRangeString(today, minDays, maxDays);
        $('.fast-shipping-arrives-day b').removeClass('skeleton-rect').text(deliveryDate);
    }
});

(() => {
  if (!window.customElements || customElements.get('product-v3-delivery-summary')) return;

  class ProductV3DeliverySummary extends HTMLElement {
    connectedCallback() {
      this.source = this.closest('.product-v3')?.querySelector('.product-v3-form-delivery');
      if (!this.source) return;
      this.sync = () => this.updateSummary();
      this.observer = new MutationObserver(this.sync);
      this.observer.observe(this.source, {
        childList: true,
        characterData: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['style', 'class', 'hidden'],
      });
      this.updateSummary();
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      this.observer = null;
      this.source = null;
    }

    updateSummary() {
      const clean = (text) => (text || '').replace(/\s+/g, ' ').trim();
      const arrival = this.source.querySelector('.fast-shipping-arrives-box');
      let delivery = '';

      if (arrival && !arrival.closest('[hidden], .hide') && getComputedStyle(arrival).display !== 'none') {
        const date = arrival.querySelector('.fast-shipping-arrives-day b:not(.skeleton-rect)');
        if (clean(date?.textContent)) delivery = `Arrives ${clean(date.textContent)}`;
      } else {
        const status = this.source.querySelector('.grid-product-est');
        const label = clean(status?.querySelector('.grid-product-variant-title__left')?.textContent);
        const value = clean(status?.querySelector('.grid-product-est__field')?.textContent);
        if (value) delivery = [label, value].filter(Boolean).join(' ');
      }

      const summary = [delivery, clean(this.dataset.summarySuffix)].filter(Boolean).join(' · ');
      if (this.textContent !== summary) this.textContent = summary;
      this.hidden = !summary;
    }
  }

  customElements.define('product-v3-delivery-summary', ProductV3DeliverySummary);
})();
